import React from "react";
import useSWR from "swr";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "./Card";
import './stylesComponent/Carrusel.css';
import "swiper/css";
import Swal from 'sweetalert2';


const getProductos = async ([urlCursos, urlClases]) => {
    try{
        const [cursosRes, clasesRes] = await Promise.all([
            fetch(urlCursos, {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            }),
            fetch(urlClases, {
              method: "GET",
              headers: { "Content-Type": "application/json" },
            }),
        ]);


        if (!cursosRes.ok || !clasesRes.ok) {
            throw new Error("cursos o clases no encontrados o error en la respuesta");
        }

        let [cursos, clases] = await Promise.all([
            cursosRes.json(),
            clasesRes.json(),
        ]);

         const filtrarEliminados = (prod) => {
            return (
                prod.Nombre !== null &&
                prod.Descripcion !== null &&
                prod.Tematica !== null &&
                prod.ImagenPortada !== null &&
                prod.FechaSubida !== null
            );
        };

        cursos = cursos.filter(filtrarEliminados);
        clases = clases.filter(filtrarEliminados);

    
        const lista_productos = [
            ...cursos.map(curso => ({ ...curso, tipo: 'curso' })), 
            ...clases.map(clase => ({
                ...clase, tipo: clase.Particular ? 'claseParticular' : 'clase'
            }))
        ];

        lista_productos.sort((a,b) => new Date(b.FechaSubida) - new Date(a.FechaSubida));

        return lista_productos.slice(0, 20);
        
    } catch (error) {
        console.error("Error al obtener los productos " + error.message);
    }
};


const Carrusel = () => {
    //const [productos, setProductos] = useState([]);
    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';

    const { data: productos = [], error, mutate: mutateProductos  } = useSWR(
        [`${baseUrl}/api/cursos/`, `${baseUrl}/api/clases/`],
        getProductos,
        { 
            revalidateOnReconnect: false,
            keepPreviousData: true,
            revalidateOnFocus: false,
            dedupingInterval: 30 * 60 * 1000,
         }
    );

    if (error) {
        console.error("Error al obtener los productos:", error);
    }

    
        
    /*useEffect(() => {
        getProductos();
    }, []);*/

    return (
        <div className="App">
            <h3>Cursos y clases recientes</h3>

            <div className="container">
                <div className="swiperContainer">
                    <Swiper 
                        modules={[Pagination, Autoplay]}
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false
                        }}
                        pagination={{
                            el: '.pagination',
                            clickable: true,
                        }}
                        slidesPerView={5}
                        centeredSlides={true}
                        spaceBetween={16}
                        breakpoints={{
                            0: {
                            slidesPerView: 1,
                            spaceBetween: 16
                            },
                            536: {
                            slidesPerView: 2,
                            spaceBetween: 16
                            },
                            792: {
                            slidesPerView: 3,
                            spaceBetween: 16
                            },
                            1048: {
                            slidesPerView: 4,
                            spaceBetween: 16
                            },
                            1304: {
                            slidesPerView: 5,
                            spaceBetween: 16
                            }
                        }}
                    >
                        {productos?.map((prod) => (
                            <SwiperSlide key={prod?._id}>
                                <Card producto={prod} />
                            </SwiperSlide>
                        ))}   
                        <div className="pagination"></div>     
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default Carrusel;
